export default "__VITE_ASSET__oEcFWQCm__"